import { Trans, useTranslation } from 'react-i18next';
import CountUp from '../../effects/CountUp/CountUp';
import LogoLoop from '../../effects/LogoLoop/LogoLoop';
import Marker from '../../ui/Marker/Marker';
import Section from '../../ui/Section/Section';
import SectionHeader from '../../ui/SectionHeader/SectionHeader';
import { siteStats } from '../../../data/siteStats';
import { techStack } from '../../../data/techStack';
import { useLanguage } from '../../../i18n/useLanguage';
import styles from './NumbersSection.module.css';

export default function NumbersSection() {
    const { t } = useTranslation();
    const { language } = useLanguage();

    return (
        <Section theme="light" shape="sheet" id="numbers" labelledBy="numbers-title">
            <div className="page-inner">
                <SectionHeader id="numbers-title" title={<Trans i18nKey="home.numbers.title" components={{ mark: <Marker /> }} />} />
                <dl className={styles.stats}>
                    {siteStats.map((stat) => (
                        <div key={stat.id} className={styles.stat}>
                            <dt className={styles.label}>{t(`home.numbers.labels.${stat.id}`)}</dt>
                            <dd className={styles.value}>
                                <CountUp to={stat.value} language={language} suffix={stat.suffix} />
                            </dd>
                        </div>
                    ))}
                </dl>
            </div>
            <div className={styles.stack}>
                <p className={`page-inner ${styles.stackTitle}`}>{t('home.numbers.stackTitle')}</p>
                <LogoLoop logos={techStack} label={t('home.numbers.stackTitle')} />
            </div>
        </Section>
    );
}
